<template>
  {{format(props.value, options)}}
</template>
<script setup>
import { computed } from 'vue'
import { format } from '@/helpers/NumberFormatLib.js'


const props = defineProps({
  value: {
    type: [String, Number],
    required: true
  },
  usePrecision: {
    type: Boolean,
    required: false,
    default: true
  },
  precision: {
    type: Number,
    required: false,
    default: 2
  },
  thousandSep: {
    type: String,
    required: false,
    default: " "
  },
  decimalSep: {
    type: String,
    required: false,
    default: "."
  }
})

/**
 * Computed, not a plain object. The callers feed these from user preferences, which hydrate after
 * the first render, and from a column's number format, which the user can change while the value
 * is on screen. A snapshot taken at setup froze the format at whatever the fallback was, so the
 * separators and the precision never changed again for the life of the component.
 */
const options = computed(() => ({
  usePrecision: props.usePrecision,
  precision: props.precision,
  thousandSep: props.thousandSep,
  decimalSep: props.decimalSep
}))

</script>
